<!-- @format -->

<ad-entry-tag>


  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item"><a href="/ad" class="projects">公募案件を探す</a></li>
      <li class="breadcrumb-item"><a href="/ad/detail/{ad_id}">詳細</a></li>
      <li class="breadcrumb-item"><h1>エントリー完了</h1></li>
    </ul>
  </div><!--/.container_breadcrumb-->
  
  <div class="contents">
    <section class="contents_area">
      <div class="contents_block detail">
        
        <p class="important_message important_message02 margin-spacing-4_bottom">公募案件へのエントリーが完了しました。</p>
        
        <div class="wrap_button margin-spacing-3_top">
          <div class="button button-secondary-large" style="cursor:pointer" onclick={goAd}>公募案件一覧に戻る</div>
        </div>
      
        
      </div><!--/.contents_block-->
    </section><!--/.contents_area-->
  </div><!--/.contents-->


<script>
  import di from "dependeny-injection";

  export default {
    ad_id: false,
    detail: {},
    goAd(){
      di.router.push(`/ad`);
    },
    entry(e) {
      di.router.push(`/ad/detail/${this.ad_id}/entry`);
    },
    onBeforeMount(props, state) {
      if (!props.routeParams[0]) {
        return;
      }
      this.ad_id = props.routeParams[0];
    }
  }
</script>
</ad-entry-tag>
